import "./AffiliateCenter.css";
import { Modal, Button } from "react-bootstrap";
import { useState } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";

function Wallet() {
  const [showWithdraw, setshowWithdraw] = useState(false);
  const [showBank, setshowBank] = useState(false);

  const hadnleShowWithdraw = () => {
    setshowWithdraw(true);
  };
  const hadnleNotShowWithdraw = () => {
    setshowWithdraw(false);
  };

  const hadnleShowBank = () => {
    setshowBank(true);
  };
  const hadnleNotShowBank = () => {
    setshowBank(false);
  };
  return (
    <>
      <div className="wallet_container">
        <div className="wallet_cards_top">
          <div className="wallet_balance_card">
            <div className="balance_icon_wrapper">
              <img
                src="/build/Balance.svg"
                alt="Balance"
                width={32}
                height={32}
              />
            </div>
            <div>
              <p className="balance_label">Current Balance</p>
              <h4 className="balance_value">$5,000.00</h4>
            </div>
          </div>
          
          <div className="wallet_withdraw_section">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h4 className="withdraw_title">Withdraw Amount</h4>
              <span className="ac_helper_text" style={{margin: 0}}>Min: $50.00</span>
            </div>
            
            <div className="ac_form_group">
              <Form.Control
                type="text"
                placeholder="Enter amount to withdraw (e.g. 500)"
                className="ac_input"
              />
              <p className="ac_helper_text mt-2">* Withdrawals are processed within 24-48 hours after KYC verification.</p>
            </div>
            
            <div className="withdraw_footer">
              <button className="ac_next_btn" style={{padding: '8px 40px'}} onClick={hadnleShowWithdraw}>
                Submit Request
              </button>
            </div>
            
            <Modal
              show={showWithdraw}
              onHide={hadnleNotShowWithdraw}
              centered
              className="custom_modal"
            >
              <Modal.Body className="p-4 text-center">
                <div className="mb-4">
                  <img src="/build/congratulation.svg" alt="KYC Required" width={100} height={100} />
                </div>
                <h5 className="affiliate_modal_head mb-3">Verification Required</h5>
                <p className="affiliate_modal_content mb-4">
                  To ensure the security of your funds, please complete your KYC verification before making your first withdrawal.
                </p>
                <div className="d-flex gap-3 justify-content-center">
                  <Button
                    className="affiliate_cancel_btn"
                    onClick={hadnleNotShowWithdraw}
                  >
                    Maybe Later
                  </Button>
                  <Button
                    className="affiliate_save_btn"
                    onClick={hadnleNotShowWithdraw}
                  >
                    Start KYC Now
                  </Button>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </div>

        <div className="wallet_accounts_section">
          <h4 className="withdraw_title mb-4">Withdraw To</h4>
          <div className="accounts_grid">
            <div className="account_card">
              <div className="account_icon">
                <img
                  src="/build/Axis.svg"
                  alt="Axis Bank"
                  width={40}
                  height={40}
                />
              </div>
              <div className="account_info">
                <h5>Axis Bank 8974</h5>
                <p>Savings Account</p>
              </div>
            </div>

            <div className="account_card">
              <div className="account_icon">
                <img
                  src="/build/StandarcChartered.svg"
                  alt="Standard Chartered"
                  width={40}
                  height={40}
                />
              </div>
              <div className="account_info">
                <h5>Standard Chartered 4423</h5>
                <p>Savings Account</p>
              </div>
            </div>

            <div className="account_card">
              <div className="account_icon">
                <img
                  src="/build/Paypal.svg"
                  alt="PayPal"
                  width={40}
                  height={40}
                />
              </div>
              <div className="account_info">
                <h5>PayPal</h5>
                <p>Connected Account</p>
              </div>
            </div>

            <div className="account_card add_account_card" onClick={hadnleShowBank}>
              <div className="account_icon mb-2">
                <img
                  src="/build/Add_bank.svg"
                  alt="Add Bank"
                  width={30}
                  height={30}
                />
              </div>
              <div className="account_info">
                <h5>Add New Method</h5>
                <p>Bank or PayPal</p>
              </div>
            </div>
          </div>

          <Modal
            show={showBank}
            onHide={hadnleNotShowBank}
            centered
            size="lg"
            className="custom_modal"
          >
            <Modal.Body className="p-4">
              <h5 className="affiliate_modal_head mb-4">Add Withdrawal Method</h5>
              <div className="row">
                <div className="col-md-6">
                  <div className="ac_form_group mb-3">
                    <Form.Label>Country</Form.Label>
                    <Form.Select className="ac_input">
                      <option>Select Country</option>
                      <option>United States</option>
                      <option>India</option>
                      <option>United Kingdom</option>
                    </Form.Select>
                  </div>
                  <div className="ac_form_group mb-3">
                    <Form.Label>Payment Type</Form.Label>
                    <Form.Select className="ac_input">
                      <option>Bank Transfer</option>
                      <option>PayPal</option>
                    </Form.Select>
                  </div>
                  <div className="ac_form_group mb-3">
                    <Form.Label>Full Name on Account</Form.Label>
                    <Form.Control className="ac_input" placeholder="As it appears on your ID" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="bg-light p-3 rounded" style={{border: '1px solid #edf2f7'}}>
                    <div className="ac_form_group mb-3">
                      <Form.Label>Account Number / IBAN</Form.Label>
                      <Form.Control className="ac_input" placeholder="Your account identifier" />
                    </div>
                    <div className="ac_form_group mb-3">
                      <Form.Label>Routing / Swift Code</Form.Label>
                      <Form.Control className="ac_input" placeholder="Bank routing number" />
                    </div>
                    <label className="ac_checkbox_wrapper mb-2">
                      <input type="checkbox" className="ac_checkbox_input" />
                      <span className="checkbox_text" style={{fontSize: '13px'}}>Set as primary withdrawal method</span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="d-flex gap-3 justify-content-end mt-4">
                <Button className="affiliate_cancel_btn" onClick={hadnleNotShowBank}>
                  Cancel
                </Button>
                <Button className="affiliate_save_btn" onClick={hadnleNotShowBank}>
                  Save Method
                </Button>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default Wallet;
